import BannerItem from "./components/bannerItem";
import BannerBigImage from "./components/bigItem";

export default function MovieBanner2() {

  const imgList = [
    {
      img: 'https://s199.imacdn.com/vg/2022/09/29/43f2da5f1837cf3b_b558cee683f756d8_8608116644394186118684.jpg',
      name: 'Mushikaburi-hime'
    },
    {
      img: 'https://s199.imacdn.com/vg/2022/09/30/a7e9aa3df86f5d2f_5070b7ae07f0ee08_5197291664512590361628.jpg',
      name: 'Chainsaw Man'
    },
    {
      img: "https://s199.imacdn.com/vg/2022/09/29/aa417ef789a9f13d_b20d51a063a0c24f_9643416644298769118684.jpg",
      name: 'Mob Psycho 100'
    },
    {
      img: "https://s199.imacdn.com/vg/2021/06/07/dc699e07c7b0c300_ad1f1107033e9a79_49785216230505676118684.jpg",
      name: 'Mairimashita! Iruma-kun'
    },
    {
      img: "https://s199.imacdn.com/vg/2022/10/16/5687ac1535aa75f3_3cf7b4134929515a_17397416659043816118684.jpg",
      name: 'Boku no Hero Academia',
    },
    {
      img: "https://s199.imacdn.com/vg/2022/09/29/b56fce5cacb03fb6_134319ec837d9e2f_13034116644384378118684.jpg",
      name: 'Spy x Family',
    },
    {
      img: "https://s199.imacdn.com/vg/2022/10/16/8e2c8ed8a262d4af_83157df455cda53f_57249616659053194118684.jpg",
      name: 'Noumin Kanren no Skill Bakka Agetetara Nazeka Tsuyoku Natta.'
    },
    {
      img: "https://s199.imacdn.com/vg/2022/10/03/daa38ec8d1ea0ed7_cdca5e5f41e247bd_25351916647948976118684.jpg",
      name: 'Sứ Mạng Thần Chết'
    },
  ]
  return <div className="container mx-auto pt-2 grid grid-rows-4 grid-cols-4 gap-2">
    <BannerBigImage img={imgList[0]?.img} name={imgList[0]?.name} />
    {
      imgList.slice(1, 8).map((item, index) => {
        return <BannerItem img={item.img} className={`col-span-2 sm:col-span-1 ${index > 1 ? 'hidden sm:block' : ''}`} key={index} />
      })
    }
  </div>
}